export enum globalDialogStatus {
    initialLoading,
    loaded,
    loadFailed,
}

export interface dialogState {
    status: globalDialogStatus;
}